export default __webpack_public_path__ + "static/media/IMG_8597.7f2cd696.JPG";